<template>
  <h1
    v-if="h1"
    :class="$style['section-title']">
    {{ title }}
  </h1>
  <h2
    v-else-if="h2"
    :class="$style['section-title']">
    {{ title }}
  </h2>
  <div
    v-else
    :class="$style['section-title']">
    {{ title }}
  </div>
</template>

<script lang="ts" setup>

  const props = defineProps<{
    title: string
    h1?: boolean
    h2?: boolean
  }>()
</script>

<style lang="less" module>
  .section-title {
    font-size: 20px;
    font-family:
      PingFangSC-Medium,
      PingFang SC,
      sans-serif;
    font-weight: 500;
    color: #333;
    line-height: 28px;
    position: relative;
    padding: 0 0 0 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 54px);

    &::before {
      content: '';
      position: absolute;
      width: 3px;
      height: 18px;
      background: @app-color;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 3px;
    }
  }
</style>
